import {
	Box,
	Link as MuiLink,
	Stack,
	Typography,
	useTheme,
} from "@mui/material";
import { ArrowRight } from "lucide-react";
import type { FC, ReactNode } from "react";
import { Link as RouterLink } from "react-router-dom";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";

interface DashboardNotificationSectionFrameProps {
	title: string;
	showAllHref?: string;
	children: ReactNode;
	testId?: string;
}

export const DashboardNotificationSectionFrame: FC<
	DashboardNotificationSectionFrameProps
> = ({ title, showAllHref, children, testId }) => {
	const theme = useTheme();
	const { t } = useResource();

	return (
		<Stack
			data-testid={testId}
			sx={{ backgroundColor: theme.palette.grey[100] }}
		>
			<Typography
				fontSize={11}
				fontWeight={600}
				color={theme.palette.grey[600]}
				sx={{
					textTransform: "uppercase",
					letterSpacing: 0.5,
					px: 1.6,
					pt: 1.2,
					pb: 0.8,
				}}
			>
				{title}
			</Typography>
			{children}
			{showAllHref ? (
				<MuiLink
					component={RouterLink}
					to={showAllHref}
					underline="none"
					data-testid={testId ? `${testId}-show-all` : undefined}
				>
					<Stack
						direction="row"
						alignItems="center"
						gap={0.4}
						sx={{ px: 1.6, py: 1.2 }}
					>
						<Typography
							fontSize={14}
							fontWeight={500}
							color={theme.palette.primary.main}
						>
							{t(Resources.Dashboard.NotificationSections.ShowAll)}
						</Typography>
						<ArrowRight size={16} color={theme.palette.primary.main} />
					</Stack>
				</MuiLink>
			) : (
				<Box sx={{ pb: 1.2 }} />
			)}
		</Stack>
	);
};
